export interface Faq {
  q: string
  a: string
}

export const FAQS: Faq[] = [
  {
    q: 'How accurate is the dormer calculator?',
    a: 'The calculator gives a planning-grade estimate, typically within 15 percent of real-world quotes for standard builds. It uses average US material and labor rates. Local prices, site access, structural surprises and design complexity can move the final cost, so always get written quotes.',
  },
  {
    q: 'How much does a dormer cost?',
    a: 'Most dormers cost between $15,000 and $80,000 installed. Small decorative dormers cost less, and wide shed dormers that add a full room cost more. Use the calculator for a figure based on your exact dimensions.',
  },
  {
    q: 'Do I need planning permission to build a dormer?',
    a: 'It depends on where you live. Many rear dormers are allowed under permitted development in England, while most US towns require a building permit. Conservation areas, listed buildings and flats have stricter rules. Always confirm with your local authority.',
  },
  {
    q: 'What is the difference between a shed dormer and a gable dormer?',
    a: 'A shed dormer has a single sloping roof and gives the most interior space for the cost. A gable dormer has a pitched roof with a triangular front, looks more traditional, and is more complex to build.',
  },
  {
    q: 'What roof pitch should a dormer have?',
    a: 'Shed dormers typically use between 3:12 and 6:12 so water drains well and headroom stays generous. Gable dormers usually match the main roof pitch. Anything below 2:12 needs specialist roofing.',
  },
  {
    q: 'Does the calculator include labor?',
    a: 'Yes. The cost estimate uses installed unit prices, which include both materials and labor. The materials list shows the quantities you or your contractor would order.',
  },
  {
    q: 'Can I use metric units?',
    a: 'Yes. Switch between feet and metres at the top of the calculator. Results update instantly and costs are shown in US dollars.',
  },
  {
    q: 'How long does it take to build a dormer?',
    a: 'A typical single dormer takes two to six weeks on site once permits are approved. Design, permit approval and material lead times can add one to three months before work starts.',
  },
  {
    q: 'Will a dormer add value to my home?',
    a: 'A well-designed dormer that adds a bedroom or bathroom often returns a significant share of its cost in resale value, and it can improve everyday comfort. The return depends on your local market and the quality of the finish.',
  },
]
